module.exports = __webpack_public_path__ + "static/media/margarita.8376e810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/margarita.jpg
// module id = 203
// module chunks = 0